import PropTypes from 'prop-types';

const LinkedInEmbed = ({ embedUrl, kind = 'post', caption }) => {
  if (!embedUrl) {
    return (
      <div className='my-6 rounded-lg bg-gray-100 p-6 text-center'>
        <p>Invalid LinkedIn embed URL.</p>
      </div>
    );
  }

  const title = kind === 'video' ? 'LinkedIn video' : 'LinkedIn post';
  const sourceUrl = embedUrl.replace('/embed/feed/update/', '/feed/update/');

  return (
    <figure className='linkedin-embed my-8 w-full overflow-hidden'>
      <div className='mx-auto w-full max-w-[550px]'>
        <iframe
          className={`block w-full border-0 ${kind === 'video' ? 'h-[500px] sm:h-[399px]' : 'h-[520px] sm:h-[399px]'}`}
          src={embedUrl}
          title={title}
          loading='lazy'
          allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
          allowFullScreen
          referrerPolicy='strict-origin-when-cross-origin'
        />
      </div>
      {caption ? <figcaption className='mt-2 text-center font-rubik text-md text-gray-500'>{caption}</figcaption> : null}
      <a
        className='sr-only focus:not-sr-only'
        href={sourceUrl}
        target='_blank'
        rel='noopener noreferrer'
      >
        Open on LinkedIn
      </a>
    </figure>
  );
};

LinkedInEmbed.propTypes = {
  embedUrl: PropTypes.string,
  kind: PropTypes.oneOf(['post', 'video']),
  caption: PropTypes.string,
};

export default LinkedInEmbed;
